import React, { useEffect, useState } from 'react';
import { Button, Input, Select } from '..';
import {
  FiFileText,
  FiEdit,
  FiTag,
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import Api from '../../Api';
import '../CompanyForm/style.css';

export default function CategoryForm({ companyId, initialData, onSuccess, onCancel, categories = [], companies = [] }) {
  const isEdit = !!initialData;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    name: '',
    type: 'Despesa',
    description: '',
    parent_id: '',
    company_id: companyId || '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData(prev => ({
        ...prev,
        ...initialData,
        parent_id: initialData.parent_id || '',
        company_id: initialData.company_id || companyId || '',
      }));
    }
  }, [initialData, companyId]);

  // Filter potential parents:
  // 1. Must be same type (optional but recommended)
  // 2. Cannot be itself
  const parentOptions = categories
    .filter(c => {
      if (isEdit && c.id === initialData.id) return false;
      if (formData.type && c.type !== formData.type) return false;
      return true;
    })
    .map(c => ({ value: c.id, label: c.name }));

  function handleChange(event) {
    const { id, value } = event.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  }

  function handleParentChange(e) {
      setFormData(prev => ({ ...prev, parent_id: e.target.value }));
  }

  function validateForm() {
    const messages = [];

    if (!formData.name || !formData.name.trim()) {
      messages.push('Informe o nome da categoria.');
    }

    if (!formData.company_id) {
      messages.push('Selecione uma empresa.');
    }

    if (!formData.type || !formData.type.trim()) {
      messages.push('Selecione o tipo da categoria.');
    }

    if (messages.length > 0) {
      messages.forEach(message => toast.error(message));
      return false;
    }

    return true;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');

    const isValid = validateForm();
    if (!isValid) return;

    setLoading(true);

    const payload = {
      ...formData,
      parent_id: formData.parent_id || null,
    };

    try {
      if (isEdit) {
        await Api.updateCategory(initialData.company_id, initialData.id, payload);
        toast.success('Categoria atualizada com sucesso!');
      } else {
        await Api.createCategory(formData.company_id, payload);
        toast.success('Categoria criada com sucesso!');
      }
      onSuccess();
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        'Ocorreu um erro ao salvar. Tente novamente.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="company-form-component" onSubmit={handleSubmit}>
      <div className="form-body">
        {error && <div className="form-error-banner">{error}</div>}

        <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '0px' }}>
          <Select
             id="company_id"
             label="Empresa *"
             value={formData.company_id}
             onChange={handleChange}
             options={companies.map(c => ({ value: c.id, label: c.trade_name || c.corporate_name }))}
             placeholder="SELECIONE UMA EMPRESA..."
             searchable
          />
        </div>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
          <Input
            id="name"
            label="Nome"
            value={formData.name}
            onChange={handleChange}
            placeholder="Ex: Material de Escritório"
            icon={FiFileText}
          />
        </div>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', marginTop: '10px' }}>
          <Select
            id="type"
            label="Tipo"
            value={formData.type}
            onChange={handleChange}
            icon={FiTag}
            searchable
            options={[
              { value: 'Receita', label: 'Receita' },
              { value: 'Despesa', label: 'Despesa' },
            ]}
          />
           <Select
            id="parent_id"
            label="Categoria Pai (Opcional)"
            value={formData.parent_id}
            onChange={handleParentChange}
            icon={FiTag}
            searchable
            options={[{ value: '', label: 'Nenhuma' }, ...parentOptions]}
          />
        </div>

        <div className="form-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
          <Input
            id="description"
            label="Descrição"
            value={formData.description}
            onChange={handleChange}
            placeholder="Informações adicionais..."
            icon={FiEdit}
            multiline
            rows={4}
          />
        </div>
      </div>

      <div className="form-actions">
        <Button
          type="button"
          className="cancel-button"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar'}
        </Button>
      </div>
    </form>
  );
}
